import React from "react";
import PropTypes from "prop-types";
import { Link, withRouter } from "react-router-dom";
import { AppBar, CssBaseline, MenuItem, Toolbar, Typography } from "@material-ui/core";
import { createTheme, withStyles, ThemeProvider } from '@material-ui/core/styles';
import styled from "styled-components/macro";
import { ButtonAppBarCollapse } from ".";


const brandLogo = "https://portofolio-web.s3.ap-northeast-2.amazonaws.com/rv-logo.png";

// const baseColor = "#E55578";
const baseColor = "#000";

const theme = createTheme({
	typography: {
		fontFamily: [
			'Enriqueta', 'serif', '-apple-system', 'BlinkMacSystemFont','"Segoe UI"', 'Roboto', 
		].join(',')
	}
})

const styles = {
	root: {
		flexGrow: 1,
		position: "-webkit-sticky",
		position: "sticky",
		top: 0,
		bottom: 20,
		zIndex: 1,
	},
	appBar: {
		[theme.breakpoints.down("xs")]: {
			padding: "0 1rem 0 0"
		},
		padding: "0 4rem 0 2rem",
		boxShadow: "none",
		background: "rgba(255,255,255,0.8)"
		// borderBottom: `1px solid ${baseColor}`
	},
	logo: {
		flexGrow: 1,
		marginLeft: "0.5rem",
		textAlign: "left",
	},
	menu: {
		[theme.breakpoints.down("xs")]: {
			display: "none",
    },
		marginLeft: "1rem",
		marginRight: "1rem",
		fontWeight: 600,
		fontFamily: `${theme.typography.fontFamily}`
	},
	buttonCollapse: {
		[theme.breakpoints.up("sm")]: {
      display: "none"
    },
		margin: "10px",
    boxShadow: "none"
	}
}

const Logo = styled.img.attrs({
	src: `${brandLogo}`
})`
	width: 3rem;
	height: 2.4rem;
`;

const PureLink = styled(Link)`
	text-decoration: none;
	color: black;
`;

const HeaderTypography = styled(Typography).attrs({
	variant: "h6",
	color: "inherit",
})``;


function Navigation(props) {
	const { classes } = props;
	return (
		<ThemeProvider theme={theme}>
			<div className={classes.root}>
				<AppBar position="static" color="rgba(255,255,255,0.5)" className={classes.appBar}>
					<Toolbar variant="dense">
						<Typography variant="h6" color="inherit" className={classes.logo}>
							<PureLink to="/">
								<Logo />
							</PureLink>
						</Typography>
						<ButtonAppBarCollapse>
							<MenuItem>
								<PureLink to='/'>Home</PureLink>
							</MenuItem>
							<MenuItem>
								<PureLink to='/about-me'>About</PureLink>
							</MenuItem>
							<MenuItem>
								<PureLink to='/contact'>Contact</PureLink>
							</MenuItem>
						</ButtonAppBarCollapse>
						<HeaderTypography className={classes.menu}>
							<PureLink to="/">
								Home
							</PureLink>
						</HeaderTypography>
						<HeaderTypography className={classes.menu}>
							<PureLink to="/profile">
								Profile
							</PureLink>
						</HeaderTypography>
						<HeaderTypography className={classes.menu}>
							<PureLink to="/contact">
								Contact
							</PureLink>
						</HeaderTypography>
					</Toolbar>
				</AppBar>
			</div>
		</ThemeProvider>
	)
}

Navigation.propTypes = {
	classes: PropTypes.object.isRequired
};

export default withRouter(withStyles(styles)(Navigation));